import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {from, Observable, of, throwError} from 'rxjs';
import {AuthService} from '../auth/AuthService';
import {Router} from '@angular/router';
import {iClient} from '../Model/ClientModel';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SmtpService {

  constructor(private httpClient: HttpClient,
                private authService: AuthService,
                private router: Router) {}

  getSmtpDetails(clientId: number): Observable<any> {
  return this.authService.getP(
    `${environment.patientService}client-email/client/${clientId}`
  );
  }
  registerSmtp(body?:any, params?: any): Observable<any> {
    return this.authService.postP(`${environment.patientService}client-email` , body , params);
  }
  updateSmtp(id: number, body?: any): Observable<any> {
  return this.authService.put(
    `${environment.patientService}client-email/${id}`,
    body
  );
  }
  getAllSmtp(params?: any): Observable<any> {
  return this.authService.getP(`${environment.patientService}client-email`, params);
  }

}
